export default __webpack_public_path__ + "static/media/announcements_icon.71ada479.svg";